import React from 'react'
import CarouselComponent from 'site/components/Carousel'

export const News = () => {
    return <CarouselComponent></CarouselComponent>
}
